export const TAXONS_LVL_2_MAX = 11 as const;

export const TAXONS_LVL_3_SHOW_ALL_THRESHOLD = 5 as const;
export const TAXONS_LVL_3_TRUNCATED_COUNT = TAXONS_LVL_3_SHOW_ALL_THRESHOLD - 1;

export const MEGAMENU_DEBOUNCE_MILLIS = 200;
